import { OperacaoEnum } from "core/resources/enums/conta";

import { Flex } from "@chakra-ui/react";
import SelectableButton from "components/Button/SelectableButton";

import colors from "core/resources/theme/colors";
import { useContaStore } from "features/conta/store";

function TableTags() {
  const {
    filters: {
      cobrancaUnificada,
      operacao,
      pago,
      atraso,
      acordo,
      pagamentoDuplicado,
      conciliado,
      naoConciliado,
    },
    update,
  } = useContaStore();

  return (
    <Flex flex={1} justifyContent="center" gridGap="8px" flexWrap="wrap">
      <SelectableButton
        selected={pago === true}
        onClick={() => {
          update({
            page: 1,
            atraso: null,
            pago: true,
          });
        }}
        onUnselect={() => {
          update({
            page: 1,
            atraso: null,
            pago: null,
          });
        }}
        rounded="full"
        selectedColor={colors.blue300}
        fontSize="14px"
      >
        Pagos
      </SelectableButton>
      <SelectableButton
        selected={pago === false}
        onClick={() => {
          update({
            page: 1,
            atraso: false,
            pago: false,
          });
        }}
        onUnselect={() => {
          update({
            page: 1,
            atraso: null,
            pago: null,
          });
        }}
        rounded="full"
        selectedColor={colors.green500}
        fontSize="14px"
      >
        Em Aberto
      </SelectableButton>

      <SelectableButton
        selected={!!atraso}
        onClick={() => {
          update({
            page: 1,
            pago: null,
            atraso: true,
          });
        }}
        onUnselect={() => {
          update({
            page: 1,
            atraso: null,
          });
        }}
        rounded="full"
        selectedColor={colors.red500}
        fontSize="14px"
      >
        Em Atraso
      </SelectableButton>
      {operacao === OperacaoEnum.Receita ? (
        <>
          <SelectableButton
            selected={acordo === 1}
            onClick={() => {
              update({
                page: 1,
                acordo: 1,
              });
            }}
            onUnselect={() => {
              update({
                page: 1,
                acordo: null,
              });
            }}
            rounded="full"
            selectedColor={colors.green500}
            fontSize="14px"
          >
            Acordo
          </SelectableButton>

          <SelectableButton
            selected={cobrancaUnificada === 1}
            onClick={() => {
              update({
                page: 1,
                cobrancaUnificada: 1,
              });
            }}
            onUnselect={() => {
              update({
                page: 1,
                cobrancaUnificada: null,
              });
            }}
            rounded="full"
            selectedColor={colors.accentBlue}
            fontSize="14px"
          >
            Cobrança unificada
          </SelectableButton>

          <SelectableButton
            selected={pagamentoDuplicado === 1}
            onClick={() => {
              update({
                page: 1,
                pagamentoDuplicado: 1,
              });
            }}
            onUnselect={() => {
              update({
                page: 1,
                pagamentoDuplicado: null,
              });
            }}
            rounded="full"
            selectedColor={colors.yellow500}
            fontSize="14px"
          >
            Pagamento duplicado
          </SelectableButton>

          <SelectableButton
            selected={conciliado === "1"}
            onClick={() => {
              update({
                page: 1,
                conciliado: "1",
                naoConciliado: null
              });
            }}
            onUnselect={() => {
              update({
                page: 1,
                conciliado: null,
              });
            }}
            rounded="full"
            selectedColor={colors.green500}
            fontSize="14px"
          >
            Conciliado
          </SelectableButton>

          <SelectableButton
            selected={naoConciliado === "1"}
            onClick={() => {
              update({
                page: 1,
                naoConciliado: "1",
                conciliado: null
              });
            }}
            onUnselect={() => {
              update({
                page: 1,
                naoConciliado: null,
              });
            }}
            rounded="full"
            selectedColor={colors.yellow500}
            fontSize="14px"
          >
            Não conciliado
          </SelectableButton>
        </>
      ) : null}
    </Flex>
  );
}

export default TableTags;
